import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { useGetAllEmployeesForList } from 'src/hooks/employees/get-all-employees-for-list.hook';
import { useGetDocumentImporter } from 'src/hooks/document-importer/get-document-importer-by-id.hook';

import { DocumentImporterPreviewTable } from '../document-importer-preview-table';

import { SKIP_LABEL } from '../../document-importer-list.constants';
import { HeaderPreviewContainer } from '../../document-importer-list.styles';

const PreviewDocumentImporter = ({
  documentId,
  currentCompanyId,
  onClose,
}: {
  documentId: string;
  currentCompanyId?: string;
  onClose: () => void;
}) => {
  const { t } = useTranslation(['common', 'documentImporter']);

  const { documentImporter, loading } = useGetDocumentImporter(documentId);

  const { employees, loading: employeeLoading } = useGetAllEmployeesForList({
    filter: { companyId: currentCompanyId },
  });

  const { title, importedDocuments = [] } = documentImporter;

  const employeesOptions = [
    SKIP_LABEL,
    ...employees?.map((el: any) => ({
      label: `${el?.profile?.displayName} (${el?.employeePersonalInfo?.employeeNumber})`,
      value: el?._id,
    })),
  ];

  const files = importedDocuments?.map(
    ({ fileName, memberId, fileId }: { fileName: string; memberId: string; fileId: string }) => ({
      name: fileName,
      uid: fileId,
      memberId,
    })
  );

  return (
    <Fragment>
      <HeaderPreviewContainer>
        <Icon
          icon={ICONS.arrowBack}
          size={24}
          color={PLATFORM_THEME_COLORS.grayVariations.dark}
          onClick={onClose}
        />
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t(`documentImporter:labels.preview`, {
            name: title,
          })}
        </Typography>
      </HeaderPreviewContainer>
      <DocumentImporterPreviewTable
        loading={employeeLoading || loading}
        employeesOptions={employeesOptions}
        dataSource={files}
        isPreview
      />
    </Fragment>
  );
};

export default PreviewDocumentImporter;
